import { Reducer, Action } from 'redux'
import { ICarrierEquipmentState, ICarrierEquipment } from 'types/carrier'
import { EQUIPMENT_ACTION_TYPES } from '../actions/equipment'

const {
  CARRIER_EQUIPMENT_FAILURE,
  CARRIER_EQUIPMENT_REQUEST,
  CARRIER_EQUIPMENT_SUCCESS,
} = EQUIPMENT_ACTION_TYPES

const defaultState: ICarrierEquipmentState = {
  equipment: [],
  fetching: false,
}

interface IErrorAction extends Action<string> {
  error?: string
}

interface ISuccessAction extends Action<string> {
  payload: {
    equipment: ICarrierEquipment[]
    canDropTrailer?: boolean
  }
}

type EquipmentAction = Action<string> | IErrorAction | ISuccessAction

const equipmentReducer: Reducer<ICarrierEquipmentState, EquipmentAction> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case CARRIER_EQUIPMENT_REQUEST: {
      return {
        ...state,
        fetching: true,
      }
    }

    case CARRIER_EQUIPMENT_SUCCESS: {
      const { canDropTrailer, equipment } = (action as ISuccessAction).payload
      return {
        ...state,
        fetching: false,
        equipment,
        canDropTrailer,
      }
    }

    case CARRIER_EQUIPMENT_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: (action as IErrorAction).error,
      }
    }

    default:
      return state
  }
}

export default equipmentReducer
